<input #fileInput type="file" (change)="onFileInput($event)" style="display:none;"/>

<div class="d-flex align-items-center">
  <div class="me-3" *ngIf="value && value !== null">
    <img class="preview" [src]="value">
  </div>
  <div class="align-items-end">
    <button type="button" class="btn btn-outline-theme" (click)="fileInput.click()"><i class="fi fi-br-upload me-2"></i>
      <span *ngIf="!value || value === null">Upload a file</span>
      <span *ngIf="value && value !== null">Change file</span>
    </button>
    <p class="mb-0 mt-2" *ngIf="type === 'image'"><small>JPG, GIF or PNG, Max Size {{maxsize}}MB</small></p>
    <p class="mb-0 mt-2" *ngIf="type !== 'image'"><small>Word, Excel, PPT, PDF, Max Size 10MB</small></p>
  </div>

</div>

